<template>
  <v-card
    flat
    class="initiative-flow-card"
    :class="cardClasses"
    @click="emitSelect"
  >
    <v-layout
      row
      align-center
      class="px-3 py-2 initiative-flow-card__content"
      :class="contentClasses"
    >
      <v-icon v-if="showDragHandle" color="grey" class="drag-handle mr-2">
        mdi-drag
      </v-icon>

      <v-avatar size="40" class="grey lighten-4 mr-3">
        <v-icon color="green darken-1">mdi-whatsapp</v-icon>
      </v-avatar>

      <v-flex v-if="hasInitiative" class="initiative-flow-card__info">
        <InitiativeDisplay :initiative="initiative" />
      </v-flex>

      <v-flex v-else-if="loading" class="py-2">
        <v-progress-circular indeterminate size="24" width="2" color="primary" />
      </v-flex>

      <v-flex v-else class="body-1 grey--text">
        {{ placeholderText }}
      </v-flex>

      <template v-if="showActions">
        <v-divider vertical class="mx-3 my-2" />
        <v-btn
          v-if="editable"
          outline
          color="primary"
          class="ma-0 text-none"
          :to="editUrl"
          target="_blank"
          @click.stop
        >
          <v-icon small left>mdi-pencil-outline</v-icon>
          Editar
        </v-btn>
        <v-btn
          v-if="removable"
          outline
          small
          color="red"
          class="ma-0 initiative-flow-card__icon-btn"
          title="Remover iniciativa"
          @click.stop="emitRemove"
        >
          <v-icon small>mdi-trash-can-outline</v-icon>
        </v-btn>
      </template>
    </v-layout>
  </v-card>
</template>

<script>
import InitiativeDisplay from '@/components/ui/InitiativeDisplay.vue'

export default {
  name: 'InitiativeFlowCard',
  components: { InitiativeDisplay },
  props: {
    initiative: { type: Object, default: null },
    highlighted: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    showDragHandle: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
    editUrl: { type: String, default: '/initiatives' },
    removable: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Clique para selecionar uma iniciativa' },
    disabledPlaceholder: { type: String, default: 'Selecione a iniciativa principal primeiro' }
  },
  computed: {
    hasInitiative () {
      return !!this.initiative
    },
    cardClasses () {
      return {
        'tertiary': this.highlighted,
        'initiative-flow-card--clickable': !this.disabled
      }
    },
    contentClasses () {
      return {
        'deep-purple lighten-5': this.highlighted
      }
    },
    placeholderText () {
      if (this.disabled) return this.disabledPlaceholder
      return this.placeholder
    },
    showActions () {
      return (this.editable && this.hasInitiative) || this.removable
    }
  },
  methods: {
    emitSelect () {
      if (this.disabled) return
      this.$emit('select')
    },
    emitRemove () {
      this.$emit('remove')
    }
  }
}
</script>

<style scoped>
.v-card.initiative-flow-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
  transition: filter 0.2s ease;
}

.initiative-flow-card--clickable {
  cursor: pointer;
}

.initiative-flow-card--clickable:hover {
  filter: brightness(0.98);
}

.initiative-flow-card__content {
  min-height: 72px;
}

.initiative-flow-card__info {
  min-width: 0;
}

.initiative-flow-card__icon-btn {
  min-width: 36px;
  width: 36px;
  height: 36px;
  padding: 0;
}

.drag-handle {
  cursor: grab;
}
</style>
